<template>
<BasePanel
        headline="lang_LABEL_TRACKS_CAPTION_MEDIA"
        :alvqa="alvqa"
    >

    <template v-slot:panelContent>

        <v-data-table
                :headers="headers"
                :items="listItems"
                hide-default-footer
                :header-props="{ sortIcon: '' }"
                :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
                class="noMinWidth"
            >
            <!-- TOP SLOT -->
            <template v-slot:top>
                    <v-row class="pb-3">
                        <v-spacer></v-spacer> 
                        <v-col cols="3">
                            <BaseButton 
                                @click="openMediaUploader()"
                                :disabled="$route.params.alvId === 'new'"
                                label="lang_GENERAL_BUTTON_ADD_ROW"
                                block
                                :alvqa="alvqa + '-button-add-row'"
                            />
                        </v-col>
                    </v-row>
            </template>

            <!-- Headers -->
            <template v-for="(header, i) in headers" v-slot:[`header.${header.value}`]>
                <span :alvqa="header.alvqa" :key="i">{{ header.text }}</span>
            </template>


            <!-- <template v-slot:[`item.mediaPreviewCoverImage`]="item">
                <div v-if="item.item.type ==='jpeg' || item.item.type ==='png'  && (item.item.link !== undefined && item.item.link !== null)">
                    <v-img 
                        :alvqa="alvqa + '-list-row-' + item.item.alvId + '-icon-play'"
                        :src="item.item.link"
                        width="40px"
                    ></v-img>
                </div>
            </template> -->

            <!-- Items -->
            <template v-slot:[`item.media`]="item">
                    <div :alvqa="alvqa + '-list-row-text-media'">
                        {{
                           item.item.name
                        }}
                    </div>
            </template>
            
            <!-- <template v-slot:[`item.type`]="item"> -->
            <template v-slot:[`item.type`]="item">
                    <div :alvqa="alvqa + '-list-row-text-media'">
                        {{
                            item.item.type.toUpperCase()
                        }}
                    </div>
            </template>    

            <!-- <template v-slot:[`item.primary`]="item">
                    <div :alvqa="alvqa + '-list-row-text-media'">
                        <BaseCheckbox 
                            :context="context"
                            :label="''"
                            :valueOuter="item.item.name"
                            :changeFunction="checkAsPrimary(item.item)"
                            hideDetails
                            class="mt-0"
                            :alvqa="alvqa + '-checkbox-own'"
                            
                        />
                    </div>
            </template> -->
            
            <template v-slot:[`item.delete`]="item">
                        <!-- Get path from BE -->
                        <BaseIcon   
                            :alvqa="alvqa + '-list-row-icon-donwload'"                        
                            icon="delete"
                            tooltipText="lang_GENERIC_CAPTION_DELETE"
                            @click="deleteFile(item)"
                        />
            </template>
        </v-data-table>

    </template>
</BasePanel>
  
</template>

<script>

import BasePanel from '@/components/_base/BasePanel'
import BaseIcon from '@/components/_buttons/BaseIcon'
import BaseButton from '@/components/_buttons/BaseButton'
import BaseCheckbox from '@/components/_base/BaseCheckbox'

export default {
    name:'TracksMediaEditPanel',

    components: { 
        BasePanel,
        BaseIcon,
        BaseButton,
        BaseCheckbox
    },

    data(){
        return{
            alvqa: 'label-tracks-edit-form-panel-media',
            context:'TracksMedia'
        }
    },

    computed: {
        headers() {
            return [
                // {
                //     text: '', 
                //     value: 'mediaPreviewCoverImage',
                //     align: 'center', 
                //     width: "65px", 
                //     class: 'text-no-wrap'
                // }, 
                {
                    text: this.$t("lang_LABEL_SALES_DATA_CAPTION_FILE_NAME"), 
                    align: "left", 
                    value: "media",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-artist'
                },
                {
                    text: 'Type', 
                    align: "left", 
                    value: "type",
                    class: 'text-no-wrap',
                    sortable: false,
                    alvqa: this.alvqa + '-header-artist'
                },
                // {
                //     text: 'Primary', 
                //     align: "left", 
                //     value: "primary",
                //     class: 'text-no-wrap',
                //     sortable: false,
                //     alvqa: this.alvqa + '-header-artist'
                // },
                {
                    text: '', 
                    align: 'right', 
                    value: 'delete',
                    sortable: false,
                    width: "70px",
                    class: 'text-no-wrap'
                }
            ]
        },

        listItems() { 
             return this.$store.getters.getTracksMedia           
         },
    },

    methods:{
        openMediaUploader(){
            this.$store.commit("setShowMediaFileUploadDialog",true)
        },
        deleteFile(item){
            //DElete call 
            //BODY - {"mediaType" : <wav|mp3>}
            //LINK-  label/tracks/<alvid>?deleteMedia
            let clickedMediaType = item.item.type
            let mediaFileId = item.item.id
            this.$store.dispatch("deleteLabelTracksMediaFile",{clickedMediaType,mediaFileId})
            
        },
        checkAsPrimary(item){
            /**
             * 0) Make a for loop and give each item in the list an id
             * 1) Go through the complete list of media items
             * 2) Find those that have the same type where primary is true and !name
             * 3) Take it out of the getTracksMediaCheckbox
             */
            let checkedAsPrimaryArray = this.$store.getters.getTracksMediaCheckbox
            let mediaTracksArray = this.$store.getters.getTracksMedia

            for (const checkBoxItem of checkedAsPrimaryArray) {
                if(checkBoxItem === item.name){
                    item['primary'] = true
                }else{
                    item['primary'] = false
                }
            }

            /**
             * There can be only 1 primary file for Picture/MP3 and WAV file
             * The function checks if there is another element of the same type is already checked
             * and uncheckes a primary property from it.
             * After that the new file of the same type is checked as primary
             */
            mediaTracksArray.forEach((element,id) => {
                if(element.type === item.type && element.primary === true && element.name !== item.name){
                    element.primary = false
                    checkedAsPrimaryArray.filter(primaryItem => primaryItem !== element.name)
                }
            });
        }
        
    }

}

</script>



<style>

</style>